import { render, staticRenderFns } from "./FeedbackManagerComponent.vue?vue&type=template&id=7683bd7e&scoped=true&lang=html&"
import script from "./FeedbackManagerComponent.vue?vue&type=script&lang=js&"
export * from "./FeedbackManagerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7683bd7e",
  null
  
)

export default component.exports